import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Form } from 'antd';
import { InputNumber } from 'ui/styled';
import { formatMoney, parseMoney } from 'utils/helpers';
import LabeledTooltip from '../LabeledTooltip';
var Item = Form.Item;
var getValidationRules = function (name, label) {
    var commonRule = {
        required: true,
        message: "".concat(label, " is required and cannot be negative")
    };
    if (name === 'cost_not_covered') {
        return [
            commonRule,
            function (_a) {
                var getFieldValue = _a.getFieldValue;
                return ({
                    validator: function (_, value) {
                        return value > getFieldValue('cost')
                            ? Promise.reject(new Error('Total pays should not exceed the value of the `Procedure/Consultation`.'))
                            : Promise.resolve();
                    }
                });
            }
        ];
    }
    return [commonRule];
};
var CostInput = function (_a) {
    var onChange = _a.onChange, name = _a.name, label = _a.label, dataTest = _a.dataTest, placeholder = _a.placeholder, tooltipText = _a.tooltipText;
    return (_jsx(Item, { name: name, rules: getValidationRules(name, label), label: _jsx(LabeledTooltip, { label: label, tooltipText: tooltipText }), labelAlign: "left", colon: false, children: _jsx(InputNumber, { min: 0, formatter: function (value) { return formatMoney(value); }, parser: function (value) { return parseMoney(value); }, onChange: function (value) { return onChange(value, name); }, "data-test": dataTest, placeholder: placeholder, disabled: name === 'cost_not_covered' }) }));
};
export default CostInput;
